export default function Django_Include_Models() {
  return <div>Django_Include_Models Component</div>;
}
